//RUTAS OPERACIONES
export const urlGetOperaciones = "/api/camiones/resumen1";
export const urlGetOperaciones2 = "/api/camiones/resumen2";
export const urlGetUninegSaf = "/api/saf/unineg";
